// src/components/store/sections/faqs/FaqV37AccordioncleanOceanCyan.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV37AccordioncleanOceanCyan(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={37}
      archKey="accordion_clean"
      archLabel="Clean Emerald Accordion"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
